import type { NavigateToolCall } from '../types';

export const navigate = (call: NavigateToolCall) => {
  const { url } = call.metadata;
  if (!url.startsWith('/')) return;
  window.location.assign(url);
};
